import React from 'react';
import PropTypes from 'prop-types';
import './InfoWindow.scss';

import Button from '../Button/Button';

/**
 * @description InfoWindow component replaces native Google Map info window
 *
 * @returns {<InfoWindow />}
 */
const InfoWindow = props => {
  const infoWindowPosition = {
    display: 'block',
    position: 'absolute',
    top: `${props.position.y -
      props.dimension.height -
      (props.dimension.markerHeight + props.dimension.offset)}px`,
    left: `${props.position.x - props.dimension.width / 2}px`,
  };

  return (
    <div id="info-window" className="tsla-twotip" style={infoWindowPosition}>
      <div className="tsla-twotip__body">
        <p className="body-copy">{props.text}</p>
        <Button label={props.buttonLabel} handleClick={props.handleButtonClick} />
      </div>
    </div>
  );
};

InfoWindow.propTypes = {
  dimension: PropTypes.shape({
    markerHeight: PropTypes.number,
    offset: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  position: PropTypes.objectOf(PropTypes.number).isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default InfoWindow;
